import { Component } from '@angular/core';

@Component({
  selector: 'app-page-break',
  templateUrl: './page-break.component.html',
  styleUrls: ['./page-break.component.scss'],
  standalone :false
})
export class PageBreakComponent {

}
